gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
// ========================================================================================================== GSAP MATCHMEDIA
let coMM = gsap.matchMedia();
// ========================================================================================================== SMOOTHER
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  coMM.add("(min-width: 750px)", () => {
    ScrollSmoother.create({
      smooth: 1,
      effects: true,
      smoothTouch: 0.75
    });
  });

}
// ========================================================================================================== CURSOR
const cursor = cursorDot({
    easing: 5
  });
console.log(cursor.parentElement);
// cursor.over("a", "co-mouseover-links");
// cursor.over("li", "co-mouseover-links");
// cursor.over("button", "co-mouseover-links");
// ===================================================== HOME SECTION 5
cursor.over(".co-home-section-5-column-button", "co-cursor-co-home-section-5-column-button");

// ========================================================================================================== IMAGE LOADER
// IMAGE LOADER
const coImagesGlobalLoader1 = document.querySelectorAll('img.co-img-loader');
coImagesGlobalLoader1.forEach((img) => {
    const coHandleImageLoad1 = () => {
        img.classList.add("co-img-loaded");
    };
    if (img.complete) {
        img.classList.add("co-img-completed");
    } else {
        img.addEventListener('load', coHandleImageLoad1);
    }
});
//X IMAGE LOADER
const coImagesGlobalLoader = document.querySelectorAll('img.co-image-global-loader');
coImagesGlobalLoader.forEach((img) => {
    // Function to handle when an image is loaded
    const coHandleImageLoad = () => {
        // console.log("image loaded");
        img.classList.add("co-image-loaded");
    };
    // Check if the image is already loaded
    if (img.complete) {
        // coHandleImageLoad();
        img.classList.add("co-image-completed");
        // console.log("image complete");
    } else {
        img.addEventListener('load', coHandleImageLoad);
    }
});
// ========================================================================================================== PROGRESS BAR
function updateCSSVariable(value) {
  document.documentElement.style.setProperty('--co-progress', `${value}%`);
}
function detectAndHandleOpana() {
  const element = document.getElementById('co-progress-bar-factor');
  if (element) {
    updateCSSVariable(element.value || element.textContent || 0);
    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
      element.addEventListener('input', () => updateCSSVariable(element.value || 0));
      element.addEventListener('change', () => updateCSSVariable(element.value || 0));
    }
    const elementObserver = new MutationObserver(() => {
      updateCSSVariable(element.value || element.textContent || 0);
    });
    elementObserver.observe(element, {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: false,
    });
  } else {
    updateCSSVariable(0);
  }
}
function observeOpanaChanges() {
  const parent = document.body;
  const observer = new MutationObserver(() => {
    detectAndHandleOpana();
  });
  observer.observe(parent, {
    childList: true,
    subtree: true,
  });
  detectAndHandleOpana();
}
document.addEventListener('DOMContentLoaded', observeOpanaChanges);
